import SearchChips from 'components/SearchInputs/SearchChips/SearchChips';
import SectionHeader from 'components/Basic/SectionHeader/SectionHeader';
import SelectPitchers from 'components/SearchInputs/SelectPitchers';
import { useReportId } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import SelectPlayerSession from 'components/SearchInputs/SelectPlayerSession';
import usePracticePitcherSingleSessionReport from 'hooks/PracticeReport/PitcherSingle/usePracticePitcherSingleSessionReport';
import SelectPracticeSessionType from 'components/SearchInputs/SelectPracticeSessionType';
import SelectTimePeriod from 'components/SearchInputs/SelectTimePeriod';

type Props = {
  isSearchCriteriaOpen: boolean;
  setSearchCriteriaOpen: () => void;
};

const PracticePitcherSingleSessionSearchCriteria = ({ isSearchCriteriaOpen, setSearchCriteriaOpen }: Props) => {
  const { isCreate } = useReportId();

  const { searchCriteria, setSearchCriteria, searchChips } = usePracticePitcherSingleSessionReport();

  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        isOpen={isSearchCriteriaOpen}
        onClick={isCreate ? setSearchCriteriaOpen : undefined}
        title={t('Populate report')}
        isEnabled={isCreate}
      />
      {isSearchCriteriaOpen ? (
        <div className='report-layout-shelf-section'>
          <SelectPracticeSessionType
            playerType='Pitcher'
            selectedPracticeSessionTypeId={searchCriteria.sessionType?.id}
            onChange={(sessionType) =>
              setSearchCriteria({
                sessionType,
                dateRanges: undefined,
                seasonNames: undefined,
                players: undefined,
              })
            }
          />
          <SelectTimePeriod
            selectedSeasonNames={searchCriteria.seasonNames}
            onChange={(seasonNames, dateRanges) =>
              setSearchCriteria({
                dateRanges,
                seasonNames,
                players: undefined,
                sessions: undefined,
              })
            }
          />
          <SelectPitchers
            selectedPitchers={searchCriteria.players}
            onChange={(players) => setSearchCriteria({ players, sessions: undefined })}
            dateRanges={searchCriteria.dateRanges}
            levelId={undefined}
            teamId={undefined}
          />
          <SelectPlayerSession
            playerType='Pitcher'
            selectedSession={searchCriteria.sessions}
            onChange={(sessions) => setSearchCriteria({ sessions })}
            dateRanges={searchCriteria.dateRanges}
            team={undefined}
            playerIds={searchCriteria.players?.map((player) => player.id)}
            levelId={undefined}
            gameType={undefined}
          />
        </div>
      ) : (
        searchChips.dateRanges && (
          <SearchChips
            seasonNames={undefined}
            dateRanges={searchChips.dateRanges}
            otherChips={{ ...searchChips, dateRanges: undefined, seasonNames: undefined }}
          />
        )
      )}
    </>
  );
};

export default PracticePitcherSingleSessionSearchCriteria;
